module.exports = __webpack_public_path__ + "img/san-1.094fa0ee.jpeg";